const BASE_URL = process.env.REACT_APP_STAKING_API_URL;


export async function fetchStakedPublisherNFTs(wallet) {
    const res = await fetchStakedNFTs(wallet, "publishernft")
    return res.result;
}

export async function fetchStakedGenesisTokens(wallet) {
    const res = await fetchStakedNFTs(wallet, "genesistoken")
    return res.result;
}

export async function fetchStakedNFTs(wallet, type) {
    if(!type) throw new Error("staking asset type is undefined!")

    try {
        // limit, offset
        const url = `${BASE_URL}/staker/${type}/${wallet}`;

        const res = await fetch(url)

        if(!res.ok) {   // returns 404 if user doesn't have anything staked
            // const err = await res.text();
            // throw new Error(err);
            return { result: [], total: 0 }
        }
        
        return res.json();
    } catch(e) {
        throw e;
    }
}

export async function fetchEduPrice() {
    try {
        const url = `${BASE_URL}/token/quotes/edu`;

        const res = await fetch(url);

        if(!res.ok) {
            throw new Error("Failed to fetch edu price")
        }

        const data = await res.json();

        return data.quote["USD"].price;
    } catch(e) {
        throw e;
    }
}